(()=>{
function validateInput(config, input) {
  const pack = config.packages.find(p => p.id === input.packageId);
  if (!pack) throw new Error('package');
  const email = String(input.email || '').trim();
  if (email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) throw new Error('email');
  if (input.consent !== true) throw new Error('consent');
  if (input.website) throw new Error('invalid');
  return { pack, email };
}

function isLiveReady(config, origin) {
  return config.mode === 'live' && config.publicationApproved === true &&
    config.privacyReviewed === true && config.botanicalClaimsReviewed === true && config.italianOptInVerified === true &&
    config.audienceIsolationVerified === true &&
    /^https:\/\/[^/]+$/.test(config.allowedOrigin) && config.allowedOrigin === origin;
}

function subscriptionPayload(config, input) {
  const { pack, email } = validateInput(config, input);
  return { data: {
    type: 'subscription',
    attributes: {
      custom_source: 'RESTORE Italia launch notification',
      profile: { data: { type: 'profile', attributes: {
        email,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
        properties: {
          restore_it_launch_interest: true,
          restore_it_package: pack.id,
          restore_it_planned_price_eur: pack.priceCents / 100,
          restore_it_language: 'it',
          restore_it_experiment: config.experiment,
          restore_it_consent_version: config.consentVersion,
          restore_it_consent_scope: 'italy_launch_notification_only'
        }
      } } }
    },
    relationships: { list: { data: { type: 'list', id: config.listId } } }
  } };
}

async function submitInterest(config, input, origin, transport = globalThis.fetch) {
  const payload = subscriptionPayload(config, input);
  if (config.mode === 'preview') return { status: 'preview' };
  if (!isLiveReady(config, origin)) throw new Error('unavailable');
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 15000);
  try {
    const response = await transport(
      `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(config.companyId)}`,
      { method: 'POST', mode: 'cors', credentials: 'omit', referrerPolicy: 'no-referrer',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: config.revision },
        body: JSON.stringify(payload), signal: controller.signal }
    );
    if (response.status !== 202) throw new Error(response.status === 429 ? 'rate' : 'network');
    // Accepted is not equivalent to a confirmed double-opt-in subscription.
    return { status: 'pending' };
  } finally { clearTimeout(timeout); }
}

function init(){

const configNode = document.querySelector('#restore-it-config');
if (!configNode) return;
const config = JSON.parse(configNode.textContent);
const currentForm = document.querySelector('#waitlist-form');
if (!currentForm || currentForm.dataset.initialized) return;
currentForm.dataset.initialized = 'true';
const form = document.querySelector('#waitlist-form');
const options = document.querySelector('#package-options');
const panel = document.querySelector('#signup-panel');
const status = document.querySelector('#form-status');
const opener = document.querySelector('#open-signup');
const submit = document.querySelector('#submit-signup');
const email = document.querySelector('#email');
const consent = document.querySelector('#launch-consent');
const eur = cents => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(cents / 100);
const galleryMain = document.querySelector('#gallery-main');
const galleryDialog = document.querySelector('#gallery-dialog');
const galleryFull = document.querySelector('#gallery-full');
const galleryButtons = [...document.querySelectorAll('[data-gallery]')];
options.replaceChildren();
galleryButtons.forEach(button => button.addEventListener('click', () => {
  const index = button.dataset.gallery;
  galleryMain.src = button.querySelector('img').src;
  galleryMain.alt = button.getAttribute('aria-label');
  galleryButtons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  document.querySelector('#gallery-caption').textContent = `${index} / ${galleryButtons.length} · ${galleryMain.alt}`;
}));
document.querySelector('.gallery-zoom').addEventListener('click', () => {
  galleryFull.src = galleryMain.src;
  galleryFull.alt = galleryMain.alt;
  galleryDialog.showModal();
});
document.querySelector('.gallery-close').addEventListener('click', () => galleryDialog.close());
galleryDialog.addEventListener('click', e => { if (e.target === galleryDialog) galleryDialog.close(); });
let busy = false;
const selected = () => config.packages.find(p => p.id === form.elements.package?.value);
const summary = p => `${p.packs} ${p.packs === 1 ? 'confezione' : 'confezioni'} · ${p.portions} porzioni · ${eur(p.priceCents)} previsti`;

function message(text, error = false) {
  status.textContent = text;
  status.dataset.error = String(error);
}

// First-party UI hooks only: no cookie, storage, pixel, dataLayer or network analytics.
// A future consent-managed adapter may consume these. Never include the email.
function event(name, pack = selected()) {
  document.dispatchEvent(new CustomEvent('restore:waitlist', { detail: {
    event: name, experiment: config.experiment, mode: config.mode,
    ...(pack ? { package_id: pack.id, planned_price_eur: pack.priceCents / 100 } : {})
  } }));
}

// Shop mode: cards mirror the German buy box (fw-plan) – thumbnail, pills, corner tag, price column.
const el = (tag, cls, text) => {
  const node = document.createElement(tag);
  if (cls) node.className = cls;
  if (text != null) node.textContent = text;
  return node;
};
const fill = (tpl, values) => Object.entries(values).reduce((out, [k, v]) => out.replaceAll(`[${k}]`, v), tpl || '');
const icons = {
  shield: '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>',
  truck: '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>'
};
function renderPlan(pack) {
  const comparison = pack.compareCents > 0 ? pack.compareCents : pack.priceCents;
  const savings = comparison - pack.priceCents;
  const night = eur(Math.round(pack.priceCents / pack.portions));
  const label = el('label', `plan${pack.ribbon ? ' plan--gold' : ''}${pack.incl ? ' plan--open' : ''}`);
  const input = el('input');
  input.type = 'radio'; input.name = 'package'; input.value = pack.id; input.autocomplete = 'off';
  input.setAttribute('aria-label', `${pack.name}, ${eur(pack.priceCents)}`);
  const card = el('span', 'plan-card');
  if (pack.ribbon) card.append(el('span', 'plan-ribbon', pack.ribbon));
  const body = el('span', 'plan-body');
  const shot = el('span', 'plan-shot');
  if (pack.image) {
    const img = el('img');
    img.src = pack.image; img.alt = ''; img.width = 180; img.height = 180; img.loading = 'lazy'; img.decoding = 'async';
    shot.append(img);
  }
  const head = el('span', `plan-head${pack.tag ? ' plan-head--mbadge' : ''}${pack.short ? ' plan-head--dbadge' : ''}`);
  head.append(el('span', 'plan-name', pack.name));
  if (pack.badge || pack.tag) {
    const badge = el('span', 'plan-badge');
    if (pack.badge) badge.append(el('span', 'plan-badge-d', pack.badge));
    if (pack.tag) badge.append(el('span', 'plan-badge-m', pack.tag));
    head.append(badge);
  }
  if (pack.short) head.append(el('span', 'plan-badge-s', pack.short));
  const prices = el('span', 'plan-prices');
  if (savings > 0) {
    const was = el('s', 'plan-compare', eur(comparison));
    was.setAttribute('aria-label', `invece di ${eur(comparison)}`);
    prices.append(was);
  }
  prices.append(el('span', 'plan-price', eur(pack.priceCents)));
  if (config.unitLabel) prices.append(el('span', 'plan-unit', fill(config.unitLabel, { nights: pack.portions, price: night })));
  body.append(shot, head, prices);
  if (config.nightLabel) body.append(el('span', 'plan-saving', fill(config.nightLabel, { price: night })));
  if (pack.note) body.append(el('span', 'plan-note', pack.note));
  const incl = (pack.incl || []).filter(Boolean);
  if (pack.flavour || incl.length) {
    const extra = el('span', 'plan-extra');
    if (pack.flavour) extra.append(el('span', 'plan-flavour', pack.flavour));
    if (incl.length) {
      if (pack.inclTitle) extra.append(el('span', 'plan-incl-title', pack.inclTitle));
      const tiles = el('span', 'plan-tiles');
      incl.forEach((text, i) => {
        const tile = el('span', 'plan-tile');
        const pic = el('span', 'plan-tile-img');
        if (i === 0 && pack.image) { const img = el('img'); img.src = pack.image; img.alt = ''; img.loading = 'lazy'; pic.append(img); }
        else pic.innerHTML = i === 1 ? icons.shield : icons.truck;
        tile.append(pic, el('span', 'plan-tile-label', text));
        tiles.append(tile);
      });
      extra.append(tiles);
    }
    body.append(extra);
  }
  card.append(el('span', 'plan-radio'), body);
  label.append(input, card); options.append(label);
  if (pack.default) { input.checked = true; document.querySelector('#selected-summary').textContent = summary(pack); }
  input.addEventListener('change', () => {
    document.querySelector('#selected-summary').textContent = summary(pack);
    message(''); event('package_selected', pack);
  });
}

if (config.shop) { options.closest('fieldset').classList.add('is-shop'); config.packages.forEach(renderPlan); }
else config.packages.forEach(pack => {
  const label = document.createElement('label');
  label.className = 'package';
  const input = document.createElement('input');
  input.type = 'radio'; input.name = 'package'; input.value = pack.id;
  const text = document.createElement('span');
  const title = document.createElement('strong');
  title.textContent = `${pack.packs} ${pack.packs === 1 ? 'confezione' : 'confezioni'}`;
  const heading = document.createElement('span');
  heading.className = 'package-heading';
  heading.append(title);
  const single = config.packages.find(p => p.packs === 1);
  // Shop mode passes its own reference price; the waitlist compares against single packs.
  const comparison = pack.compareCents > 0 ? pack.compareCents : single ? single.priceCents * pack.packs : pack.priceCents;
  const savings = comparison - pack.priceCents;
  const percent = savings > 0 ? Math.round(savings / comparison * 100) : 0;
  if (pack.tag || ((config.shop || pack.packs > 1) && savings > 0)) {
    const badge = document.createElement('span');
    badge.className = 'package-badge';
    badge.textContent = pack.tag || `−${percent}%`;
    if (!pack.tag) badge.setAttribute('aria-label', config.shop ? `Risparmio del ${percent}%` : `Risparmio previsto del ${percent}% rispetto alle confezioni singole`);
    heading.append(badge);
  }
  const subtitle = document.createElement('small');
  subtitle.textContent = `${pack.portions} porzioni · ${eur(pack.priceCents / pack.packs)} / confezione`;
  text.append(heading, subtitle);
  if (pack.packs > 1 && savings > 0) {
    const saving = document.createElement('small');
    saving.className = 'package-saving';
    saving.textContent = `Risparmi ${eur(savings)}`;
    text.append(saving);
  }
  if (pack.note) {
    const note = document.createElement('small');
    note.className = 'package-note';
    note.textContent = pack.note;
    text.append(note);
  }
  const price = document.createElement('strong');
  price.className = 'package-price'; price.textContent = eur(pack.priceCents);
  if (config.shop && savings > 0) {
    const was = document.createElement('s');
    was.className = 'package-compare';
    was.textContent = eur(comparison);
    was.setAttribute('aria-label', `invece di ${eur(comparison)}`);
    price.prepend(was);
  }
  label.append(input, text, price); options.append(label);
  if (pack.default) { input.checked = true; document.querySelector('#selected-summary').textContent = summary(pack); }
  input.addEventListener('change', () => {
    document.querySelector('#selected-summary').textContent = summary(pack);
    message(''); event('package_selected', pack);
  });
});

opener.addEventListener('click', () => {
  if (config.shop) {
    const pack = selected();
    if (!pack) { message('Scegli prima il tuo pacchetto.', true); options.querySelector('input').focus(); return; }
    event('checkout_start', pack);
    opener.disabled = true;
    // Cart permalink: fresh cart with this quantity, straight to checkout (automatic discounts apply there).
    location.href = `${config.cartUrl}/${encodeURIComponent(config.variantId)}:${pack.packs}`;
    return;
  }
  if (!selected()) {
    message('Scegli prima il pacchetto che ti interessa.', true);
    options.querySelector('input').focus(); return;
  }
  panel.hidden = false;
  opener.hidden = true;
  message(''); email.focus(); event('signup_open');
});

if (config.shop) {
  const note = document.querySelector('#preview-note');
  if (note) note.hidden = true;
} else if (config.mode !== 'preview') {
  const note = document.querySelector('#preview-note');
  if (isLiveReady(config, location.origin)) { if (note) note.hidden = true; }
  else {
    if (note) note.textContent = 'Lista d’attesa in preparazione. Le iscrizioni non sono ancora aperte.';
    message('Le iscrizioni non sono ancora aperte. Riprova più tardi.');
    opener.disabled = true; submit.disabled = true;
  }
}

const errors = {
  package: 'Scegli il pacchetto che ti interessa.',
  email: 'Inserisci un indirizzo email valido.',
  consent: 'Per ricevere l’avviso di lancio, seleziona la casella di consenso.',
  invalid: 'Non è stato possibile inviare la richiesta. Ricarica la pagina e riprova.',
  unavailable: 'Le iscrizioni non sono ancora aperte. Riprova più tardi.',
  rate: 'Troppe richieste in poco tempo. Attendi qualche minuto prima di riprovare.',
  network: 'Non siamo riusciti a verificare l’invio. Controlla la connessione e la posta prima di riprovare.'
};
form.addEventListener('submit', async e => {
  e.preventDefault();
  if (busy) return;
  if (config.shop || panel.hidden) { opener.click(); return; }
  busy = true; submit.disabled = true; form.setAttribute('aria-busy', 'true');
  email.removeAttribute('aria-invalid'); consent.removeAttribute('aria-invalid');
  const input = { packageId: selected()?.id, email: email.value, consent: consent.checked,
    website: document.querySelector('#website').value };
  const submittedPack = config.packages.find(p => p.id === input.packageId);
  try {
    const result = await submitInterest(config, input, location.origin);
    if (result.status === 'preview') {
      message('Prova completata. Questa è un’anteprima: nessuna iscrizione salvata e nessuna email inviata.');
      event('preview_submit', submittedPack);
    } else {
      message('Richiesta ricevuta. Controlla la posta, anche lo spam, e conferma tramite il link se richiesto. Se sei già iscritta, non occorre una nuova conferma.');
      event('signup_request_accepted', submittedPack);
    }
    email.value = ''; consent.checked = false;
    status.focus();
  } catch (error) {
    message(errors[error.message] || errors.network, true);
    const field = error.message === 'email' ? email : error.message === 'consent' ? consent : null;
    if (field) { field.setAttribute('aria-invalid', 'true'); field.focus(); }
    else status.focus();
  } finally { busy = false; submit.disabled = false; form.removeAttribute('aria-busy'); }
});

}
init();document.addEventListener("shopify:section:load",init);
})();
